export default "__VITE_ASSET__B63W8cI5__"